export const LOAD_OFFER_FINANCIAL_SERVICES_SUCCEEDED = "LOAD_OFFER_FINANCIAL_SERVICES_SUCCEEDED";
export const OFFER_FINANCIAL_SERVICES_COMPUTED = "OFFER_FINANCIAL_SERVICES_COMPUTED";
export const SAVE_OFFER_FINANCIAL_SERVICES_SUCCEEDED = "SAVE_OFFER_FINANCIAL_SERVICES_SUCCEEDED";
export const LOAD_WHEELS_SIZES_SUCCEEDED = "LOAD_WHEELS_SIZES_SUCCEEDED";
export const SAVE_OFFER_FINANCIAL_SERVICES_STARTED = "SAVE_OFFER_FINANCIAL_SERVICES_STARTED";
export const SAVE_OFFER_FINANCIAL_SERVICES_UPDATE_FAILED = "SAVE_OFFER_FINANCIAL_SERVICES_UPDATE_FAILED";
export const LOAD_OFFER_FINANCIAL_SERVICES_STARTED = "LOAD_OFFER_FINANCIAL_SERVICES_STARTED";
export const LOAD_WHEELS_SIZES_STARTED = "LOAD_WHEELS_SIZES_STARTED";
export const LOAD_OFFER_FINANCIAL_SERVICES_FAILED = "LOAD_OFFER_FINANCIAL_SERVICES_FAILED";
export const LOAD_WHEELS_SIZES_FAILED = "LOAD_WHEELS_SIZES_FAILED";
export const COMPUTE_OFFER_FINANCIAL_SERVICES_STARTED = "COMPUTE_OFFER_FINANCIAL_SERVICES_STARTED";
export const COMPUTE_OFFER_FINANCIAL_SERVICES_FAILED = "COMPUTE_OFFER_FINANCIAL_SERVICES_FAILED";
export const COMPUTE_OFFER_FINANCIAL_SERVICES_SUCCEEDED = "COMPUTE_OFFER_FINANCIAL_SERVICES_SUCCEEDED";
export const CANCEL_OFFER_FINANCIAL_SERVICES_CHANGES = "CANCEL_OFFER_FINANCIAL_SERVICES_CHANGES";
export const CHANGE_EDITABLE_PROPERTY = "CHANGE_EDITABLE_PROPERTY";

export const LOAD_OFFER_FINANCIAL_SERVICES_LINKING_STARTED = "LOAD_OFFER_FINANCIAL_SERVICES_LINKING_STARTED";

export const LOAD_OFFER_FINANCIAL_SERVICES_LINKING_SUCCEEDED = "LOAD_OFFER_FINANCIAL_SERVICES_LINKING_SUCCEEDED";
export const LOAD_OFFER_FINANCIAL_SERVICES_LINKING_FAILED = "LOAD_OFFER_FINANCIAL_SERVICES_LINKING_FAILED";
export const LOAD_OFFER_FINANCIAL_SERVICE_TYPES_FAILED = "LOAD_OFFER_FINANCIAL_SERVICE_TYPES_FAILED";
export const LOAD_OFFER_FINANCIAL_SERVICE_TYPES_SUCCEEDED = "LOAD_OFFER_FINANCIAL_SERVICE_TYPES_SUCCEEDED";
export const LOAD_OFFER_FINANCIAL_SERVICE_TYPES_STARTED = "LOAD_OFFER_FINANCIAL_SERVICE_TYPES_STARTED";
export const SAVE_ADDED_SERVICES_STARTED = "SAVE_ADDED_SERVICES_STARTED";
export const SAVE_ADDED_SERVICES_SUCCEEDED = "SAVE_ADDED_SERVICES_SUCCEEDED";
export const SAVE_ADDED_SERVICES_FAILED = "SAVE_ADDED_SERVICES_FAILED";
export const DELETE_SERVICE_STARTED = "DELETE_SERVICE_STARTED";
